import { render } from "./FormEditModification.vue?vue&type=template&id=181f122e&scoped=true"
import script from "./FormEditModification.vue?vue&type=script&lang=js"
export * from "./FormEditModification.vue?vue&type=script&lang=js"

import "./FormEditModification.vue?vue&type=style&index=0&id=181f122e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-181f122e"]])

export default __exports__